// Lightweight Web Audio synth for the EmotionalSignal landing.
// Generates gentle psychedelic hover tones + a subtle ambient drone.
// Audio must be started by a user gesture (the sound toggle).

let ctx = null;
let master = null;
let delay = null;
let feedback = null;
let ambient = [];
let enabled = false;

function ensure() {
  if (ctx) return;
  const AC = window.AudioContext || window.webkitAudioContext;
  ctx = new AC();
  master = ctx.createGain();
  master.gain.value = 0.0;
  master.connect(ctx.destination);
  // ambient delay/feedback for a dreamy tail
  delay = ctx.createDelay(1.0);
  delay.delayTime.value = 0.3;
  feedback = ctx.createGain();
  feedback.gain.value = 0.35;
  delay.connect(feedback);
  feedback.connect(delay);
  delay.connect(master);
}

function startAmbient() {
  if (!ctx || ambient.length) return;
  const base = [55, 82.41, 110]; // A1, E2, A2
  base.forEach((f, i) => {
    const osc = ctx.createOscillator();
    osc.type = "sine";
    osc.frequency.value = f * (1 + (Math.random() - 0.5) * 0.004);
    const g = ctx.createGain();
    g.gain.value = 0.03;
    // slow amplitude LFO
    const lfo = ctx.createOscillator();
    lfo.frequency.value = 0.05 + i * 0.02;
    const lfoGain = ctx.createGain();
    lfoGain.gain.value = 0.02;
    lfo.connect(lfoGain);
    lfoGain.connect(g.gain);
    osc.connect(g);
    g.connect(master);
    osc.start();
    lfo.start();
    ambient.push(osc, lfo);
  });
}

function stopAmbient() {
  ambient.forEach((n) => { try { n.stop(); } catch (e) {} });
  ambient = [];
}

export async function enableSound() {
  ensure();
  try { await ctx.resume(); } catch (e) {}
  enabled = true;
  master.gain.cancelScheduledValues(ctx.currentTime);
  master.gain.linearRampToValueAtTime(0.85, ctx.currentTime + 0.5);
  startAmbient();
  return true;
}

export function disableSound() {
  if (!ctx) { enabled = false; return; }
  enabled = false;
  master.gain.cancelScheduledValues(ctx.currentTime);
  master.gain.linearRampToValueAtTime(0.0, ctx.currentTime + 0.35);
  setTimeout(stopAmbient, 400);
}

export function isSoundEnabled() {
  return enabled;
}

// gentle plucked tone at a given frequency
export function blip(freq = 440) {
  if (!ctx || !enabled) return;
  const t = ctx.currentTime;
  const osc = ctx.createOscillator();
  osc.type = "triangle";
  osc.frequency.value = freq * (1 + (Math.random() - 0.5) * 0.012);
  const g = ctx.createGain();
  g.gain.setValueAtTime(0.0001, t);
  g.gain.linearRampToValueAtTime(0.22, t + 0.015);
  g.gain.exponentialRampToValueAtTime(0.0001, t + 1.1);
  const lp = ctx.createBiquadFilter();
  lp.type = "lowpass";
  lp.frequency.setValueAtTime(2600, t);
  lp.frequency.exponentialRampToValueAtTime(700, t + 1.0);
  osc.connect(lp);
  lp.connect(g);
  g.connect(master);
  g.connect(delay);
  osc.start(t);
  osc.stop(t + 1.2);
}

// pentatonic-ish notes for a psychedelic feel
export const NOTES = { eye: 523.25, heart: 392.0, nazar: 659.25, soft: 440.0, high: 783.99 };
